import { API } from '@Providers';

export default async function (payload: string) {
  const endpoint = `/api/shelter/get-temp-shopping-cart/${payload}`;

  return API({ endpoint });
}
